import React, { useState, useEffect, useContext, useRef } from "react";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { isNil } from "lodash";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import IconButton from "@material-ui/core/IconButton";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import { FormControlLabel, Switch } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { isString, isEmpty, isObject, has } from "lodash";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import SearchIcon from "@material-ui/icons/Search";
import ImageIcon from "@material-ui/icons/Image";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import axios from "axios";

import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

import useQuickMessages from "../../hooks/useQuickMessages";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    backgroundColor: theme.palette.bordabox,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: "8px 12px 10px",
  },

  newMessageBox: {
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
    width: "100%",
    display: "flex",
    padding: "4px 6px 4px 10px",
    alignItems: "center",
    borderRadius: 28,
    border: `1.5px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
    transition: "border-color 0.2s, box-shadow 0.2s",
    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 3px ${theme.palette.type === "dark" ? "rgba(45,123,232,0.2)" : "rgba(45,123,232,0.12)"}`,
    },
  },

  messageInputWrapper: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    minWidth: 0,
  },

  messageInput: {
    paddingLeft: 8,
    flex: 1,
    border: "none",
  },

  sendMessageIcons: {
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.45)" : "rgba(0,0,0,0.4)",
    transition: "color 0.15s",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.newmessagebox,
    borderTop: `1px solid ${theme.palette.divider}`,
  },

  emojiBox: {
    position: "absolute",
    bottom: "calc(100% + 8px)",
    left: 0,
    zIndex: 1300,
    borderRadius: 8,
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
  },

  emojiButtonWrapper: {
    position: "relative",
    display: "inline-flex",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  quickMsgPanel: {
    width: 340,
    maxHeight: 440,
    display: "flex",
    flexDirection: "column",
  },
  quickMsgHeader: {
    padding: theme.spacing(1.5, 1.5, 1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  quickMsgTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: theme.palette.text.primary,
  },
  quickMsgList: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  quickMsgItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": { borderBottom: "none" },
    padding: theme.spacing(1, 1.5),
  },
  quickMsgPreview: {
    fontSize: "0.78rem",
    color: theme.palette.text.secondary,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  quickMsgEmpty: {
    padding: theme.spacing(4, 2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  closedBanner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    padding: theme.spacing(0.75, 2),
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
    borderTop: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
  },

  mediaPreviews: {
    display: "flex",
    flex: 1,
    gap: 8,
    overflowX: "auto",
    alignItems: "center",
    padding: "0 8px",
    ...theme.scrollbarStyles,
  },

  mediaPreviewItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexShrink: 0,
    gap: 4,
  },

  mediaThumb: {
    width: 72,
    height: 72,
    objectFit: "cover",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    display: "block",
  },

  mediaFileChip: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "6px 10px",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)",
    borderRadius: 16,
    maxWidth: 160,
  },

  mediaFileName: {
    fontSize: "0.72rem",
    maxWidth: 120,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.text.primary,
  },

  replyMediaThumb: {
    width: 48,
    height: 48,
    objectFit: "cover",
    borderRadius: 4,
    margin: "4px 0 4px 4px",
    flexShrink: 0,
    border: `1px solid ${theme.palette.divider}`,
  },

  noteToggleActive: {
    color: "#f57c00 !important",
  },

  messageInputWrapperNote: {
    backgroundColor: `${theme.palette.type === "dark" ? "rgba(255,193,7,0.08)" : "rgba(255,193,7,0.1)"} !important`,
    borderColor: `${theme.palette.type === "dark" ? "#7c5500" : "#ffc107"} !important`,
  },

  sendButton: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    width: 36,
    height: 36,
    flexShrink: 0,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "&:disabled": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
      color: theme.palette.type === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
    },
  },

  micButton: {
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.5)",
    width: 36,
    height: 36,
    flexShrink: 0,
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },

  iconDivider: {
    width: 1,
    height: 20,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)",
    margin: "0 2px",
    flexShrink: 0,
  },
}));

const QuickMessagesPanel = ({ anchorEl, onClose, onSelect, disabled }) => {
  const classes = useStyles();
  const [search, setSearch] = useState("");
  const [messages, setMessages] = useState([]);
  const { user } = useContext(AuthContext);
  const { list: listQuickMessages } = useQuickMessages();
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const companyId = localStorage.getItem("companyId");
        const data = await listQuickMessages({ companyId, userId: user.id });
        setMessages(data || []);
      } catch (err) {
        toastError(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const filtered = messages.filter(
    (m) =>
      !search ||
      m.shortcode.toLowerCase().includes(search.toLowerCase()) ||
      m.message.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={() => { onClose(); setSearch(""); }}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "bottom", horizontal: "left" }}
      PaperProps={{ className: classes.quickMsgPanel }}
    >
      <div className={classes.quickMsgHeader}>
        <Typography variant="body2" className={classes.quickMsgTitle}>
          <FlashOnIcon fontSize="small" color="primary" />
          Mensagens Rápidas
        </Typography>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          placeholder="Buscar por atalho ou texto..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </div>

      {filtered.length === 0 ? (
        <div className={classes.quickMsgEmpty}>
          <Typography variant="body2">
            {search ? "Nenhuma mensagem encontrada" : "Nenhuma mensagem rápida cadastrada"}
          </Typography>
        </div>
      ) : (
        <List dense disablePadding className={classes.quickMsgList}>
          {filtered.map((msg) => (
            <ListItem
              key={msg.id}
              button
              disabled={disabled}
              onClick={() => { onSelect(msg); setSearch(""); }}
              className={classes.quickMsgItem}
            >
              <ListItemText
                disableTypography
                primary={
                  <Box display="flex" alignItems="center" style={{ gap: 6, marginBottom: 3 }}>
                    <Chip
                      label={`/${msg.shortcode}`}
                      size="small"
                      color="primary"
                      style={{ height: 20, fontSize: "0.7rem" }}
                    />
                    {msg.mediaPath && (
                      <Tooltip title="Contém imagem/mídia">
                        <ImageIcon style={{ fontSize: 14, color: "#888" }} />
                      </Tooltip>
                    )}
                  </Box>
                }
                secondary={
                  <span className={classes.quickMsgPreview}>{msg.message}</span>
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </Popover>
  );
};

const PlusMenu = ({ anchorEl, onClose, onAttach, onQuickMessages, signMessage, setSignMessage, disabled }) => {
  const open = Boolean(anchorEl);
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "bottom", horizontal: "left" }}
      PaperProps={{ style: { minWidth: 210 } }}
    >
      <List dense disablePadding>
        <ListItem button disabled={disabled} onClick={() => { onAttach(); onClose(); }}>
          <ListItemIcon style={{ minWidth: 36 }}>
            <AttachFileIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Anexar arquivo"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </ListItem>
        <ListItem button disabled={disabled} onClick={onQuickMessages}>
          <ListItemIcon style={{ minWidth: 36 }}>
            <FlashOnIcon fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Mensagens Rápidas"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemIcon style={{ minWidth: 36 }}>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={i18n.t("messagesInput.signMessage")}
            primaryTypographyProps={{ variant: "body2" }}
          />
          <Switch
            size="small"
            checked={signMessage}
            onChange={(e) => setSignMessage(e.target.checked)}
            color="primary"
            disabled={disabled}
          />
        </ListItem>
      </List>
    </Popover>
  );
};

const EmojiOptions = (props) => {
  const { disabled, showEmoji, setShowEmoji, handleAddEmoji } = props;
  const classes = useStyles();
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!showEmoji) return;
    const handleOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowEmoji(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [showEmoji, setShowEmoji]);

  return (
    <div className={classes.emojiButtonWrapper} ref={wrapperRef}>
      <IconButton
        aria-label="emojiPicker"
        component="span"
        disabled={disabled}
        onClick={() => setShowEmoji((prev) => !prev)}
      >
        <MoodIcon className={classes.sendMessageIcons} />
      </IconButton>
      {showEmoji ? (
        <div className={classes.emojiBox}>
          <Picker
            perLine={14}
            showPreview={false}
            showSkinTones={false}
            onSelect={(emoji) => {
              handleAddEmoji(emoji);
              setShowEmoji(false);
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

const SignSwitch = (props) => {
  const { width, setSignMessage, signMessage } = props;
  const theme = useTheme();
  if (isWidthUp("md", width)) {
    return (
      <FormControlLabel
        style={{ marginRight: 7, color: theme.palette.messageIcons }}
        label={i18n.t("messagesInput.signMessage")}
        labelPlacement="start"
        control={
          <Switch
            size="small"
            checked={signMessage}
            onChange={(e) => {
              setSignMessage(e.target.checked);
            }}
            name="showAllTickets"
            color="primary"
          />
        }
      />
    );
  }
  return null;
};

const FileInput = (props) => {
  const { handleChangeMedias, disableOption } = props;
  const classes = useStyles();
  return (
    <>
      <input
        multiple
        type="file"
        id="upload-button"
        disabled={disableOption()}
        className={classes.uploadInput}
        onChange={handleChangeMedias}
      />
      <label htmlFor="upload-button">
        <IconButton
          aria-label="upload"
          component="span"
          disabled={disableOption()}
        >
          <AttachFileIcon className={classes.sendMessageIcons} />
        </IconButton>
      </label>
    </>
  );
};

const ActionButtons = (props) => {
  const {
    inputMessage,
    loading,
    recording,
    ticketStatus,
    handleSendMessage,
    handleCancelAudio,
    handleUploadAudio,
    handleStartRecording,
  } = props;
  const classes = useStyles();
  if (inputMessage) {
    return (
      <IconButton
        aria-label="sendMessage"
        component="span"
        onClick={handleSendMessage}
        disabled={loading}
        className={classes.sendButton}
        size="small"
      >
        <SendIcon style={{ fontSize: 18 }} />
      </IconButton>
    );
  } else if (recording) {
    return (
      <div className={classes.recorderWrapper}>
        <IconButton
          aria-label="cancelRecording"
          component="span"
          fontSize="large"
          disabled={loading}
          onClick={handleCancelAudio}
        >
          <HighlightOffIcon className={classes.cancelAudioIcon} />
        </IconButton>
        {loading ? (
          <div>
            <CircularProgress className={classes.audioLoading} />
          </div>
        ) : (
          <RecordingTimer />
        )}
        <IconButton
          aria-label="sendRecordedAudio"
          component="span"
          onClick={handleUploadAudio}
          disabled={loading}
        >
          <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
        </IconButton>
      </div>
    );
  } else {
    return (
      <IconButton
        aria-label="showRecorder"
        component="span"
        disabled={loading || ticketStatus !== "open"}
        onClick={handleStartRecording}
        className={classes.micButton}
        size="small"
      >
        <MicIcon style={{ fontSize: 20 }} />
      </IconButton>
    );
  }
};

const CustomInput = (props) => {
  const {
    loading,
    inputRef,
    ticketStatus,
    inputMessage,
    setInputMessage,
    handleSendMessage,
    handleInputPaste,
    disableOption,
    handleQuickAnswersClick,
    isNoteMode,
  } = props;
  const classes = useStyles();
  const [quickMessages, setQuickMessages] = useState([]);
  const [options, setOptions] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);

  const { user } = useContext(AuthContext);

  const { list: listQuickMessages } = useQuickMessages();

  useEffect(() => {
    async function fetchData() {
      const companyId = localStorage.getItem("companyId");
      const messages = await listQuickMessages({ companyId, userId: user.id });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 35) {
          truncatedMessage = m.message.substring(0, 35) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
        };
      });
      setQuickMessages(options);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length > 1
    ) {
      const firstWord = inputMessage.charAt(0);
      setPopupOpen(firstWord.indexOf("/") > -1);

      const filteredOptions = quickMessages.filter(
        (m) => m.label.indexOf(inputMessage) > -1
      );
      setOptions(filteredOptions);
    } else {
      setPopupOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage]);

  const onKeyPress = (e) => {
    if (ticketStatus !== "open") return;
    if (e.key === "Enter") {
      if (e.shiftKey || e.ctrlKey) {
        e.preventDefault();
        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        const target = e.target;
        const before = inputMessage.substring(0, start);
        const after = inputMessage.substring(end);
        setInputMessage(before + "\n" + after);
        setTimeout(() => {
          if (target) {
            target.selectionStart = start + 1;
            target.selectionEnd = start + 1;
          }
        }, 0);
      } else if (!loading) {
        handleSendMessage();
      }
    }
  };

  const onPaste = (e) => {
    if (ticketStatus === "open") {
      handleInputPaste(e);
    }
  };

  const renderPlaceholder = () => {
    if (isNoteMode) return "Escrever anotação interna...";
    if (ticketStatus === "open") return i18n.t("messagesInput.placeholderOpen");
    return i18n.t("messagesInput.placeholderClosed");
  };


  const setInputRef = (input) => {
    if (input) {
      input.focus();
      inputRef.current = input;
    }
  };

  return (
    <div className={clsx(classes.messageInputWrapper, { [classes.messageInputWrapperNote]: isNoteMode })}>
      <Autocomplete
        freeSolo
        open={popupOpen}
        id="grouped-demo"
        value={inputMessage}
        options={options}
        closeIcon={null}
        getOptionLabel={(option) => {
          if (isObject(option)) {
            return option.label;
          } else {
            return option;
          }
        }}
        onChange={(event, opt) => {
         
          if (isObject(opt) && has(opt, "value") && isNil(opt.mediaPath)) {
            setInputMessage(opt.value);
            setTimeout(() => {
              if (inputRef.current) inputRef.current.scrollTop = inputRef.current.scrollHeight;
            }, 200);
          } else if (isObject(opt) && has(opt, "value") && !isNil(opt.mediaPath)) {
            handleQuickAnswersClick(opt);

            setTimeout(() => {
              if (inputRef.current) inputRef.current.scrollTop = inputRef.current.scrollHeight;
            }, 200);
          }
        }}
        onInputChange={(event, opt, reason) => {
          if (reason === "input") {
            setInputMessage(event.target.value);
          }
        }}
        onPaste={onPaste}
        onKeyPress={onKeyPress}
        style={{ width: "100%" }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          const autocompleteKeyDown = InputProps.onKeyDown;
          return (
            <InputBase
              {...InputProps}
              {...rest}
              disabled={disableOption()}
              inputRef={setInputRef}
              placeholder={renderPlaceholder()}
              multiline
              className={classes.messageInput}
              maxRows={5}
              onKeyPress={(e) => {
                if (ticketStatus !== "open") {
                  e.preventDefault();
                }
              }}
              onKeyDown={(e) => {
                if (ticketStatus !== "open") {
                  e.preventDefault();
                  return;
                }
                // Quando o popup de sugestões está fechado, Up/Down movem o cursor
                // normalmente no textarea — impede o Autocomplete de interceptar.
                if (!popupOpen && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
                  e.stopPropagation();
                  return;
                }
                if (autocompleteKeyDown) autocompleteKeyDown(e);
              }}
              onClick={(e) => {
                if (ticketStatus !== "open") {
                  e.preventDefault();
                  toast.info(i18n.t("messagesInput.ticketClosedInfo")); // Mensagem informativa
                }
              }}
              onPaste={(e) => {
                if (ticketStatus !== "open") {
                  e.preventDefault();
                  toast.info(i18n.t("messagesInput.ticketClosedInfo"));
                }
              }}
            />
          );
        }}
      />
    </div>
  );
};

const MessageInputCustom = (props) => {
  const { ticketStatus, ticketId } = props;
  const classes = useStyles();

  const [medias, setMedias] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const inputRef = useRef();
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);
  const [quickPanelAnchorEl, setQuickPanelAnchorEl] = useState(null);
  const [plusMenuAnchorEl, setPlusMenuAnchorEl] = useState(null);
  const fileInputRef = useRef(null);
  const [isNoteMode, setIsNoteMode] = useState(false);
  const [mediaPreviewUrls, setMediaPreviewUrls] = useState([]);

  useEffect(() => {
    const urls = medias.map((m) =>
      m.type.startsWith("image/") ? URL.createObjectURL(m) : null
    );
    setMediaPreviewUrls(urls);
    return () => { urls.forEach((url) => url && URL.revokeObjectURL(url)); };
  }, [medias]);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, [replyingMessage]);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMedias([]);
      setReplyingMessage(null);
      setIsNoteMode(false);
    };
  }, [ticketId, setReplyingMessage]);

  // const handleChangeInput = e => {
  // 	if (isObject(e) && has(e, 'value')) {
  // 		setInputMessage(e.value);
  // 	} else {
  // 		setInputMessage(e.target.value)
  // 	}
  // };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      setMedias([e.clipboardData.files[0]]);
    }
  };

  const handleUploadQuickMessageMedia = async (blob, message) => {
    setLoading(true);
    try {
      const extension = blob.type.split("/")[1];

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension}`;
      formData.append("medias", blob, filename);
      formData.append("body",  message);
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
    setLoading(false);
  };
  
  const handleQuickAnswersClick = async (value) => {
    if (value.mediaPath) {
      try {
        const { data } = await axios.get(value.mediaPath, {
          responseType: "blob",
        });

        handleUploadQuickMessageMedia(data, value.value);
        setInputMessage("");
        return;
        //  handleChangeMedias(response)
      } catch (err) {
        toastError(err);
      }
    }

    setInputMessage("");
    setInputMessage(value.value);
  };

  const handleUploadMedia = async (e) => {
    setLoading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("fromMe", true);
    medias.forEach((media) => {
      formData.append("medias", media);
      formData.append("body", media.name);
    });

    try {
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMedias([]);
  };

  const handleSendMessage = async () => {

    if (ticketStatus !== "open") {
      // Impede envio caso o ticket não esteja aberto
      return;
    }

    if (inputMessage.trim() === "") return;
    setLoading(true);

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: isNoteMode
        ? inputMessage.trim()
        : signMessage
        ? `*${user?.name}:*\n${inputMessage.trim()}`
        : inputMessage.trim(),
      quotedMsg: replyingMessage,
      isPrivate: isNoteMode,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `audio-record-site-${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const disableOption = () => {
    return loading || recording || ticketStatus !== "open";
  };

  const renderReplyingMessage = (message) => {
    const isImageReply =
      message.mediaUrl &&
      (message.mediaType === "image" ||
        message.mediaType?.startsWith("image"));
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          {isImageReply && (
            <img
              src={message.mediaUrl}
              alt=""
              className={classes.replyMediaThumb}
            />
          )}
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  if (medias.length > 0)
    return (
      <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
        <IconButton
          aria-label="cancel-upload"
          component="span"
          onClick={() => setMedias([])}
        >
          <CancelIcon className={classes.sendMessageIcons} />
        </IconButton>

        {loading ? (
          <div>
            <CircularProgress className={classes.circleLoading} />
          </div>
        ) : (
          <div className={classes.mediaPreviews}>
            {medias.map((media, idx) => (
              <div key={idx} className={classes.mediaPreviewItem}>
                {mediaPreviewUrls[idx] ? (
                  <img
                    src={mediaPreviewUrls[idx]}
                    alt={media.name}
                    className={classes.mediaThumb}
                  />
                ) : (
                  <div className={classes.mediaFileChip}>
                    <InsertDriveFileIcon style={{ fontSize: 16, flexShrink: 0 }} />
                    <Typography className={classes.mediaFileName}>
                      {media.name}
                    </Typography>
                  </div>
                )}
                {medias.length > 1 && (
                  <Typography variant="caption" style={{ fontSize: "0.65rem", color: "inherit" }}>
                    {media.name.length > 14 ? media.name.substring(0, 12) + "…" : media.name}
                  </Typography>
                )}
              </div>
            ))}
          </div>
        )}

        <IconButton
          aria-label="send-upload"
          component="span"
          onClick={handleUploadMedia}
          disabled={loading}
        >
          <SendIcon className={classes.sendMessageIcons} />
        </IconButton>
      </Paper>
    );
  else {
    return (
      <Paper square elevation={0} className={classes.mainWrapper}>
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        {ticketStatus !== "open" && (
          <div className={classes.closedBanner}>
            <LockOutlinedIcon style={{ fontSize: 14 }} />
            <Typography variant="caption">
              {ticketStatus === "pending"
                ? "Aceite o atendimento para enviar mensagens"
                : "Ticket encerrado — reabra para enviar mensagens"}
            </Typography>
          </div>
        )}
        <div className={clsx(classes.newMessageBox, { [classes.messageInputWrapperNote]: isNoteMode })}>
          <EmojiOptions
            disabled={disableOption()}
            handleAddEmoji={handleAddEmoji}
            showEmoji={showEmoji}
            setShowEmoji={setShowEmoji}
          />

          {/* Hidden file input — triggered from PlusMenu */}
          <input
            multiple
            type="file"
            id="upload-button"
            disabled={disableOption()}
            className={classes.uploadInput}
            onChange={handleChangeMedias}
            ref={fileInputRef}
          />

          {/* Botão + abre menu de opções */}
          <Tooltip title="Mais opções">
            <span>
              <IconButton
                aria-label="plusMenu"
                component="span"
                disabled={disableOption()}
                onClick={(e) => setPlusMenuAnchorEl(e.currentTarget)}
              >
                <AddCircleOutlineIcon className={classes.sendMessageIcons} />
              </IconButton>
            </span>
          </Tooltip>
          <PlusMenu
            anchorEl={plusMenuAnchorEl}
            onClose={() => setPlusMenuAnchorEl(null)}
            disabled={disableOption()}
            signMessage={signMessage}
            setSignMessage={setSignMessage}
            onAttach={() => { if (fileInputRef.current) fileInputRef.current.click(); }}
            onQuickMessages={() => {
              const el = plusMenuAnchorEl;
              setPlusMenuAnchorEl(null);
              setQuickPanelAnchorEl(el);
            }}
          />
          <Tooltip title={isNoteMode ? "Cancelar anotação interna" : "Escrever anotação interna (não enviada ao contato)"}>
            <span>
              <IconButton
                size="small"
                disabled={disableOption()}
                onClick={() => setIsNoteMode((prev) => !prev)}
                className={isNoteMode ? classes.noteToggleActive : undefined}
              >
                <SpeakerNotesIcon
                  fontSize="small"
                  className={!isNoteMode ? classes.sendMessageIcons : undefined}
                />
              </IconButton>
            </span>
          </Tooltip>

          <div className={classes.iconDivider} />

          <QuickMessagesPanel
            anchorEl={quickPanelAnchorEl}
            onClose={() => setQuickPanelAnchorEl(null)}
            disabled={disableOption()}
            onSelect={(msg) => {
              setQuickPanelAnchorEl(null);
              if (msg.mediaPath) {
                handleQuickAnswersClick({ value: msg.message, mediaPath: msg.mediaPath });
              } else {
                setInputMessage(msg.message);
                setTimeout(() => { if (inputRef.current) inputRef.current.focus(); }, 50);
              }
            }}
          />

          <CustomInput
            loading={loading}
            inputRef={inputRef}
            ticketStatus={ticketStatus}
            inputMessage={inputMessage}
            setInputMessage={setInputMessage}
            handleSendMessage={handleSendMessage}
            handleInputPaste={handleInputPaste}
            disableOption={disableOption}
            handleQuickAnswersClick={handleQuickAnswersClick}
            isNoteMode={isNoteMode}
          />

          <div style={{ marginLeft: 4 }} />
          <ActionButtons
            inputMessage={inputMessage}
            loading={loading}
            recording={recording}
            ticketStatus={ticketStatus}
            handleSendMessage={handleSendMessage}
            handleCancelAudio={handleCancelAudio}
            handleUploadAudio={handleUploadAudio}
            handleStartRecording={handleStartRecording}
          />
        </div>
      </Paper>
    );
  }
};

export default withWidth()(MessageInputCustom);
